import React from 'react';
import NewPosting from 'Components/Forum/NewPosting';
import FormSelectText from 'Components/Core/Form/FormSelectText';
import DialogSelectText from 'Components/Core/Form/DialogSelectText';


export default function NewThread(props) {

    const x = props.x;
	const selectTopicId = props.moduleId + '-select-topic-new-thread';
	const [topicId, setTopicId] = React.useState(0);

	React.useEffect(() => {
		// x.wad[props.dialogId].postingRestore();
	}, []);


	function getTopicList() {
		const forumTopics = x.was.topics.filter(
			(topic) => topic.forumid === null || topic.forumid === 0 || String(topic.forumid) === String(props.forumId)
		);
		const topicList = [{'id': 0, 'name': 'Kein Thema zuordnen'}].concat(forumTopics);
		return topicList;
	}

    return (
		<React.Fragment>
			<NewPosting 
				x={x}  
				id={props.moduleId + '-thread'}
				memberRef={props.memberRef}
				newPostingFunctions = {props.newPostingFunctions}
				showDialogAnswer={props.showDialogAnswer}
				moduleId={props.moduleId} 
				forumId={props.forumId} 
				answerTo={props.answerTo} 
				topicId={topicId}
				titleText = {
					<FormSelectText
						id={selectTopicId}
						iconMode={false}
						wafId={props.moduleId + "-form-current-topic"}
						name="topicid"
						componentId={x.wau.getComponentId()}
						moduleId={props.id}
						x={x}  
						disabled={(x.wad[props.dialogId].memberId === x.was.memberId || x.was.isAdmin()) ? false : true}
						title={(x.wad[props.dialogId].memberId === x.was.memberId || x.was.isAdmin()) ? "Diesem Beitrag ein Thema zuweisen." : "Kein Thema zugewiesen..."}
						alwaysShowSelection={false}
						afterSelect={(key, value) => {
							setTopicId(key);
						}}
						resetIcon={false}

					/>
				}
				dialogId={props.dialogId}
			/>
			<DialogSelectText 
				id={selectTopicId} 
				moduleId={props.id} 
				x={x}   
				classes="dialog-select-topics"
				onSetData={getTopicList} 
				title="Thema" 
			/>
		</React.Fragment>
    )

}

